// @ts-ignore
export const analytics = window.analytics;

export default analytics;
